const state = {

}

const actions =  {
  async sendMail({commit}, opts){
      let _this = this
      let params = opts
      let obj = {
        url: 'update-register',
        query: params,
        method: 'post',
        api: 'criare'
      }
      await _this.dispatch('request/doRequest', obj).then(resp => {
        let paramModal = {}
        paramModal.message = resp.data.message
        paramModal.title = 'Sucesso'
        paramModal.type = 'success'
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
      })
      return true
    },
}

export default {
  namespaced: true,
  root: true,
  state,
  actions
}
